var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImageProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "fq03motoka",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 112,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.44c0-8.81 0-13.215 1.687-16.592a16 16 0 0 1 7.161-7.16C12.225 0 16.63 0 25.44 0h61.12c8.81 0 13.215 0 16.592 1.687a16.003 16.003 0 0 1 7.161 7.161C112 12.225 112 16.63 112 25.44v61.12c0 8.81 0 13.215-1.687 16.592a16.007 16.007 0 0 1-7.161 7.161C99.775 112 95.37 112 86.56 112H25.44c-8.81 0-13.215 0-16.592-1.687a16.003 16.003 0 0 1-7.16-7.161C0 99.775 0 95.37 0 86.56V25.44z",
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fq03motoka)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.44c0-8.81 0-13.215 1.687-16.592a16 16 0 0 1 7.161-7.16C12.225 0 16.63 0 25.44 0h61.12c8.81 0 13.215 0 16.592 1.687a16.003 16.003 0 0 1 7.161 7.161C112 12.225 112 16.63 112 25.44v61.12c0 8.81 0 13.215-1.687 16.592a16.007 16.007 0 0 1-7.161 7.161C99.775 112 95.37 112 86.56 112H25.44c-8.81 0-13.215 0-16.592-1.687a16.003 16.003 0 0 1-7.16-7.161C0 99.775 0 95.37 0 86.56V25.44z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.904 87.749A11.771 11.771 0 0 1 56.139 99.52 11.777 11.777 0 0 1 44.367 87.75V60.894A11.772 11.772 0 0 1 56.14 49.129a11.765 11.765 0 0 1 11.765 11.765v26.855z",
    fill: "#DBDADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.197 87.746-11.269 3.187-11.268-3.187c0 5.96-32.09 6.63-44.41 16.54 6.098 8.106 17.575 14.69 26.642 19.238a65.734 65.734 0 0 0 58.47.234c9.103-4.475 20.475-9.326 26.638-17.383-12.07-10.31-44.803-12.581-44.803-18.629z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.906 44.438c2.998 5.147 2.112 11.256-1.986 13.644s-9.855.151-12.852-5.028c-2.998-5.178-2.112-11.23 1.986-13.644 4.097-2.413 9.854-.126 12.852 5.028zM72.611 44.437c-2.998 5.147-2.105 11.256 1.993 13.644 4.097 2.388 9.854.15 12.852-5.028 2.998-5.178 2.112-11.256-1.986-13.644s-9.855-.126-12.859 5.028z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.428 44.815c0 18.955-11.772 34.315-26.29 34.315-14.517 0-26.295-15.36-26.295-34.315S33.602 10.5 56.14 10.5s26.289 15.366 26.289 34.315z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.904 86.224.071 1.6c.017.365.072.734.253 1.053.536.947 1.756 2.107 3.522 2.56-3.639 2.169-9.056 4.353-14.945 4.353h-.44c-5.838-.12-11.759-2.615-15.712-4.689 2.313-.961 3.715-2.023 3.715-3.35v-1.81c3.312 1.678 7.85 3.476 12.11 3.564h.346c4.293 0 8.208-1.628 11.08-3.28z",
    fill: "#B4B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImageProfile);
export default __webpack_public_path__ + "static/media/defaultImageProfile.63d927731b52ec13600217a606fe37c6.svg";
export { ForwardRef as ReactComponent };